export const EMAIL_CONTSTANTS = {
  serviceID: 'service_4fspej7',
  templateID: 'template_6fb2xzp',
  publicKey: 'E5308yxOAEm-afE2Z',
}
